// Browser-print fallback used when the printer companion app isn't available
// (bills, reprints, returns, exchanges).
//
// The receipt is printed from a hidden iframe that is kept until the NEXT print.
// Chrome re-renders the print preview from this document while the dialog is
// open (e.g. once it has loaded a thermal printer's paper size) and fires
// `afterprint` before the dialog closes, so removing the frame right after
// print() made the preview fail ("Print preview failed", Print greyed out).
const FRAME_ID = 'pos-browser-print-frame';

export const printMarkupInWindow = ({ title, markup, styles }) => {
  // The previous print dialog is closed by now — its frame can go.
  document.getElementById(FRAME_ID)?.remove();

  const iframe = document.createElement('iframe');
  iframe.id = FRAME_ID;
  iframe.setAttribute('title', title || 'print-frame');
  iframe.setAttribute('aria-hidden', 'true');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  iframe.style.visibility = 'hidden';
  document.body.appendChild(iframe);

  const printWindow = iframe.contentWindow;
  const printDocument = iframe.contentDocument || printWindow?.document;
  if (!printWindow || !printDocument) {
    iframe.remove();
    throw new Error('Print frame unavailable');
  }

  // `size` is left to the printer driver: "80mm auto" is not a valid page size
  // (Chrome dropped it), and the thermal driver already knows its roll width.
  printDocument.open();
  printDocument.write(`<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />
    <title>${title}</title>
    <style>
      html, body { margin: 0; padding: 0; background: #fff; }
      body { font-family: monospace; }
      @page { margin: 0; }
      @media print {
        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      }
      ${styles || ''}
    </style>
  </head>
  <body>${markup}</body>
</html>`);
  printDocument.close();

  setTimeout(() => {
    printWindow.focus();
    printWindow.print();
  }, 150);
};

export const printHtml = ({ title, html, styles }) => (
  printMarkupInWindow({ title, markup: html, styles })
);
